import React from 'react';
import { useTranslation } from 'react-i18next';
import './proof-page.scss';

export interface ProofPageImage {
  src: string;
  alt: string;
}

export interface ProofPageEmail {
  from: string | null;
  subject: string | null;
  received: string | null;
}

/** The proof behind a Dream receipt, as sent by /public/artifacts/:token. */
export interface ProofPageData {
  receipt: ProofPageImage;
  screenshots: ProofPageImage[];
  emails: ProofPageEmail[];
}

const ProofPage: React.FC<{ proof: ProofPageData }> = ({ proof }) => {
  const { t } = useTranslation();
  const total = proof.screenshots.length;
  return (
    <div className='proof-page'>
      <div className='proof-page-column'>
        <img
          className='proof-page-receipt'
          src={proof.receipt.src}
          alt={proof.receipt.alt}
        />
        {proof.emails.length > 0 && (
          <section className='proof-page-section'>
            <h2>{t('artifact.proofEmailHeading')}</h2>
            {proof.emails.map((email, index) => (
              <div className='proof-page-email' key={index}>
                {email.subject && (
                  <div className='proof-page-email-subject'>
                    {email.subject}
                  </div>
                )}
                {email.from && (
                  <div className='proof-page-email-meta'>{email.from}</div>
                )}
                {email.received && (
                  <div className='proof-page-email-meta'>
                    {t('artifact.proofEmailReceived', {
                      when: email.received,
                    })}
                  </div>
                )}
              </div>
            ))}
          </section>
        )}
        {total > 0 && (
          <section className='proof-page-section'>
            <h2>{t('artifact.proofTeamSaw')}</h2>
            {proof.screenshots.map((shot, index) => (
              <figure className='proof-page-shot' key={shot.src}>
                <img src={shot.src} alt={shot.alt} loading='lazy' />
                {total > 1 && (
                  <figcaption>
                    {t('artifact.proofScreenshotOf', {
                      n: index + 1,
                      total,
                    })}
                  </figcaption>
                )}
              </figure>
            ))}
          </section>
        )}
        <div className='proof-page-stripe' aria-hidden />
        <p className='proof-page-footer'>{t('artifact.proofPrivate')}</p>
      </div>
    </div>
  );
};

export default ProofPage;
